import { makeStyles } from '@material-ui/core/styles';

export default makeStyles((theme) => ({
  circleContainer: {
    alignItems: 'center',
    display: 'flex',
    justifyContent: 'center',
  },
  title: {
    fontWeight: 700,
    fontSize: 30,
    lineHeight: '35.16px',
    color: theme.palette.primary.main,
  },
  agendaContainer: {
    '& .fc-theme-standard *': {
      border: 'none',
    },
    '& .fc-media-screen': {
      overflow: 'auto',
    },
    '& .fc-datagrid-cell': {
      backgroundColor: theme.palette.blue.lightest,
      borderRadius: 5,
    },
    '& .fc-timeline-slot': {
      backgroundColor: 'none',
    },
    '& * .fc-scrollgrid-sync-table': {
      borderCollapse: 'separate',
      borderSpacing: theme.spacing(1) + 'px',
    },
    '& .fc-timeline-header-row *': {
      backgroundColor: theme.palette.common.white,
      color: theme.palette.primary.main,
    },
    '& .fc-datagrid-header': {
      '& *': {
        backgroundColor: theme.palette.common.white,
        color: theme.palette.primary.main,
      },
    },
    '& .fc-timeline-lane': {
      backgroundColor: theme.palette.blue.lightest,
    },
    '& .fc-resource-timeline-divider': {
      width: 0,
    },
  },
  agendaHeader: {
    display: 'flex',
    justifyContent: 'flex-end',
    alignItems: 'center',
  },
  resourceHeader: {
    textAlign: 'center',
    width: '184px',
  },
  resourceLabelContainer: {
    '& .fc-datagrid-cell-frame': {
      alignItems: 'center !important',
      display: 'flex',
      justifyContent: 'center',
    },
  },
  event: {
    border: 'none !important',
    borderRadius: `${theme.shape.borderRadius}px !important`,
    margin: `${theme.spacing(0.25)}px ${theme.spacing(0.5)}px !important`,
    padding: `${theme.spacing(0.5)}px !important`,
    backgroundColor: theme.palette.common.white,
  },
  conflictEvent: {
    backgroundColor: theme.palette.error.main,
    '& *': {
      color: theme.palette.common.white,
    },
  },
  resolvedEvent: {
    backgroundColor: theme.palette.success.main,
    '& *': {
      color: theme.palette.common.white,
    },
  },
  slotText: {
    fontSize: 12,
    color: theme.palette.common.black,
  },
  view: {
    '& .fc-view': {
      width: '1500px',
    },
    '& .fc-scroller': {
      overflow: 'hidden !important',
      marginBottom: '0px !important',
    },
  },
  modalContent: {
    alignItems: 'center',
    display: 'flex',
    justifyContent: 'center',
    height: '100%',
  },
  modalText: {
    color: theme.palette.tertiary.main,
    fontSize: 24,
    fontStyle: 'italic',
    fontWeight: '300',
  },
}));
